import { createTheme, rem } from '@mantine/core';

export const theme = createTheme({
  defaultRadius: 'md',
  radius: {
    xs: rem(2),
    sm: rem(4),
    md: rem(8),
    lg: rem(12),
    xl: rem(16),
    pill: rem(9999),
  },
  fontSizes: {
    xs: rem(12),
    sm: rem(14),
    md: rem(16),
    lg: rem(20),
    xl: rem(24),
  },
  spacing: {
    xs: rem(4),
    sm: rem(8),
    md: rem(16),
    lg: rem(32),
    xl: rem(64),
  },
  lineHeights: {
    xs: '1',
    sm: '1.1',
    md: '1.3',
    lg: '1.5',
    xl: '2',
  },
});
